import { type SbBaseBlockProps } from '@/services/storyblok/storyblok'

type IframeBlockProps = SbBaseBlockProps<{
  url: { url: string }
  width: number
  height: number
}>

export function IframeBlock({ blok }: IframeBlockProps) {
  return (
    <iframe
      src={blok.url.url}
      width={blok.width}
      height={blok.height}
      referrerPolicy="no-referrer-when-downgrade"
      frameBorder={0}
      style={{ border: 0, margin: 'auto' }}
    />
  )
}
